export const containerStyles = `
    flex flex-col
    w-full px-[16px]
`
